
import { takeUntil } from 'rxjs';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { debounceTime } from 'rxjs';
import { PropertyFilter } from '../../Models/OtherClasses';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from "../../Services/ConfigService";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PropertyItemMoveBulkComponent } from '../PropertyItem/PropertyItemMoveBulkComponent';
import { CustomerPropertyItemEditComponent } from '../CustomerAccount/PropertyItemComponentEdit';

@Component({
	selector: 'PropertyItemGrid',
	templateUrl: 'PropertyItemGrid.html',
})
export class PropertyItemGridComponent extends BaseBusyableComponent {

	@Input() filterObj = new PropertyFilter();

	@Output() itemsFiltered = new EventEmitter<TooBig4Car.Logic.PropertyItem[]>();

	@Output() newClicked = new EventEmitter<any>();

	@Output() backEndSearch = new EventEmitter<PropertyFilter>();

	searchBackEnd() {
		this.backEndSearch.emit(this.filterObj);
	}
	newBtnClicked() {
		this.newClicked.emit({});
	}

	bulkMove() {
		if (this.allowBulkMove()) {
			var thisHolder = this;
			var moveObjs = this.filteredItems.filter(a => a.IsSelected && a.APICanIMoveThis);
			var idsToMove = moveObjs.map(a => a.PropertyItemID);

			var modal = thisHolder.mymodalService.open(PropertyItemMoveBulkComponent);
			modal.componentInstance.myItem = {
				PropertyItemIDs: idsToMove
			} as TooBig4Car.Logic.PropertyItemMoveBulkVM
			modal.result.then(refresh => {
				if (refresh) {
					thisHolder.refreshData.emit();
				}
			}, (reason) => {

			});
		}
	}
	allowBulkMove() :boolean {
		if (this.allowMove) {
			return this.filteredItems.filter(a => a.IsSelected).length > 0;
		}
		return false;
	}

	@Input() showBackendSearch = false;
	@Input() showDeliveryColumn = false;

	@Input() showInspectionTargetDateSeparately = false;

	@Input() showDestinationRoom = false;
	@Input() showShipment = false;

	@Input() showLocation = false;

	@Input() showDate = false;

	@Input() allowMove = false;

	@Input() showSearch: boolean = true;

	@Input() showSpecifics: boolean = true;

	@Input() showCustomer: boolean = true;

	@Input() showNewBtn: boolean = false;

	@Output() refreshData = new EventEmitter<any>();

	@Output() inspectClicked = new EventEmitter<TooBig4Car.Logic.PropertyItem>();

	inspectBtnClicked(item: TooBig4Car.Logic.PropertyItem) {
		this.inspectClicked.emit(item);
	}

	@Input() showInspectBtn: boolean = false;

	@Output() moveClicked = new EventEmitter<TooBig4Car.Logic.PropertyItem>();

	moveBtnClicked(item: TooBig4Car.Logic.PropertyItem) {
		this.moveClicked.emit(item);
	}

	@Input() showMoveBtn: boolean = false;

	constructor(
		public configData: ConfigService,
		private mymodalService: NgbModal	) {
		super();
		
		this.sortCriteria = { sortColumn: 'TypeName, Description', sortDirection: 'asc' };
		this.employee = this.configData.isEmployee();

		this.filterEmitter.asObservable()
			.pipe(
				debounceTime(300)
			)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(fobj => {
				this.innerFilterItems(fobj);
			});
	}

	employee: boolean = false;

	_items: TooBig4Car.Logic.PropertyItem[] = [];
	@Input()
	set items(val: TooBig4Car.Logic.PropertyItem[]) {
		this._items = val;
		this.innerFilterItems(this.filterObj);
	}

	get items(): TooBig4Car.Logic.PropertyItem[] {
		return this._items;
	}

	filteredItems: TooBig4Car.Logic.PropertyItem[] = [];

	onSort(newCriteria: TooBig4Car.Logic.SortCriteria) {
		super.onSort(newCriteria);
		this.filteredItems = this.configData.SortArray(this.filteredItems, this.sortCriteria);
	}

	filterEmitter: EventEmitter<PropertyFilter> = new EventEmitter<PropertyFilter>();

	preventClick(evt: any) {
		evt.preventDefault();
		evt.stopPropagation();
	}
	filterItems(evt: any) {
		this.filterEmitter.next(this.filterObj);
	}
	innerFilterItems(fobj: PropertyFilter) {
		if (!this.showBackendSearch) {
			var col: TooBig4Car.Logic.PropertyItem[] = [];
			if (fobj) {
				col = fobj.filterItems(this._items);
			} else {
				col = this._items;
			}
			this.filteredItems = this.configData.SortArray(col, this.sortCriteria);
			this.itemsFiltered.next(this.filteredItems);
		} else {
			this.filteredItems = this.configData.SortArray(this._items, this.sortCriteria);
		}
	}


	popUpEdit(item: TooBig4Car.Logic.PropertyItem) {
		var thisHolder = this;
		var modal = thisHolder.mymodalService.open(CustomerPropertyItemEditComponent);
		modal.componentInstance.loadItem(this.configData.deepClone( item));
		modal.result.then((result: TooBig4Car.Logic.PropertyItem) => {
			if (result) {
				this._items.splice(this._items.indexOf(item), 1);
				this._items.push(result);
				this.filterItems(null);
			}
		});
	}
}
